<template>
	<b-tabs content-class="mt-3" v-model="document_tab_index" pills fill justified variant="blue-navy">
		<b-tab title="VER" active>
			<b-overlay :show="loading" rounded="lg" spinner-variant="gold">
				<div class="container-documents">
					<b-row class="content-card">
						<b-col>
							<b-table-simple condensed borderless hover>
								<tbody>
									<b-tr class="d-none d-lg-table-row">
										<b-th><b>Descripción</b></b-th>
										<b-th><b>Fecha</b></b-th>
										<b-th><b>Acción</b></b-th>
									</b-tr>
									<template v-for="(document, key) in pageOfItems">
										<b-tr :key="'doc-tr'+key" class="d-none d-lg-table-row">
											<b-td>
												<h5 v-if="document.name">
													{{ document.name }}
												</h5>
												<h5 v-else>
													{{ document.type }} Nº
													<b>{{
														isNaN(document.number)
														? document.number
														: new Intl.NumberFormat("es-CL").format(
															document.number
															)
													}}</b>
												</h5>
											</b-td>
											<b-td>
												{{document.date}}
											</b-td>
											<b-td>
												<b-button :href="document.url" variant="gold" squared target="_blank" download>Descargar</b-button>
											</b-td>
										</b-tr>
										<b-tr  :key="'small-doc-tr'+key" class="d-lg-none">
											<b-td>
												<small>{{document.type}}</small><br />
												<b>Nº {{ isNaN(document.number) ? document.number : new Intl.NumberFormat("es-CL").format(document.number)}}</b><br />
												<small>{{document.date}}</small>
											</b-td>
											<b-td class="align-middle text-right">
												<b-button :href="document.url" variant="gold" squared target="_blank" download>Descargar</b-button>
											</b-td>
										</b-tr>
									</template>
								</tbody>
							</b-table-simple>
						</b-col>
					</b-row>
					<center>
						<jw-pagination :pageSize="5" :items="documents" @changePage="onChangePage" :styles="customStyles" :labels="customLabels"></jw-pagination>
					</center>
				</div>
			</b-overlay>
		</b-tab>
		<b-tab title="FIRMAR">
			<div>
				<h5 class="text-center p-4">Proximamente aquí podrás firmar tus documentos de forma segura y electrónica.</h5>
			</div>
		</b-tab>
		</b-tabs>
</template>
<script>
	export default {
		name: "documents",
		components: {},
		props: {
			asset_id: null
		},
		data() {
			return {
				document_tab_index: 0,
				loading: true,
				customStyles: {
					li: {
						display: 'inline-block',
					},
					a: {
						color: 'black'
					}
				},
				customLabels: {
					first: '<<',
					last: '>>',
					previous: '<',
					next: '>'
				},
				pageOfItems: [],
				Apartment: null,
				documents:[]
			}
		},
		beforeMount() {
			this.Apartment = this.$store.getters.getApartmentById(parseInt(this.asset_id))
			this.setDocuments()
		},
		methods: {
			setDocuments() {
				this.axios.get("contracts/"+this.Apartment.contract_id+"/get_documents").then(result => {
					this.loading = false;
					this.documents = result.data.documents;
				});
			},
			onChangePage(pageOfItems) {
				this.pageOfItems = pageOfItems;
			},
		}
	};
</script>
<style>
</style>